<div
  (click)="openDialog(item)"
   (mouseover)="hovered=true" (mouseleave)="hovered=false"
   [ngStyle]="{'background' : hovered ?  '0% 0% / cover no-repeat url(' + item.previewBgPath + ')' : ''}">
  <h3>{{ item.caption }}</h3>
  <p style="font-size: 0.7em;">{{ item.captionAdd }}</p>
</div>
